export const convertToPrettyNumber = (input: string) => {
  return input.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
